import React, { Component } from 'react';
import Notifications from '../Dropdown/Notifications';
import AuthDropDown from '../Dropdown/AuthDropDown';
import { NavLink } from 'react-router-dom';


class Layout extends Component {
    render() {
        return (
            <div id="header">
                <header className="clearfix">
                    <div className="branding">
                        <NavLink className="brand" to="/home"></NavLink>
                        <a role="button" tabIndex={0} className="offcanvas-toggle visible-xs-inline">
                            <i className="fa fa-bars" />
                        </a>
                    </div>
                    <ul className="nav-left pull-left list-unstyled list-inline">
                        <li className="leftmenu-collapse">
                            <a role="button" tabIndex={0} className="collapse-leftmenu">
                                <i className="fa fa-outdent" />
                            </a>
                        </li>
                    </ul>
                    <span style={style.head}> PEIWA </span>
                    <ul className="nav-right pull-right list-inline">
                        <Notifications />
                        <AuthDropDown />
                    </ul>
                </header>
            </div>
        )
    }
}

const style = {
    head: {
        lineHeight: '60px',
        fontSize: '20px',
    }
}

export default Layout;


// WEBPACK FOOTER //
// ./src/Components/Header/Layout.js